import List from "../List/List";
import Layout from "../layout/Layout";
import { RouteComponentProps } from "@reach/router";
import { useParams } from 'react-router-dom';
import EstablishmentsLandingView from "./EstablishmentsLandingView";
import { EntityViewTypes } from "../../../enums/EntityViewTypes";
import GetSchema from "../entityComponents/Schema";
import { EntityNames } from "../../../enums/EntityNames";
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../modules/auth/Permissions/PermissionStrings";

export default function EstablishmentsPage(props: RouteComponentProps) {
    return (
        <EstablishmentsPageContent />
    )
}

function EstablishmentsPageContent({ }) {
    const { entityName } = useParams();
    const { permissions } = usePermissions();

    function getPageTitle() {
        if (!entityName) {
            return "Establishments"
        }

        const schema = GetSchema(entityName)
        return schema.displayName
    }

    function canAddEntity(): boolean {
        if (!entityName) return false;
        
        if (entityName === EntityNames.accounts) {
            // Accounts only added directly under customer parent
            return false;
        }

        if (entityName === EntityNames.customers) {
            const canView = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Customers);
            const canAddCustomer = hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Customer_Accounts);
            const canAddAccount = hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Add_Account);
            return canView && canAddCustomer && canAddAccount;
        }
        
        return false;
    }

    return (
        <Layout entityName={entityName!} data={undefined} pageTitle={getPageTitle()} showBackButton={entityName ? true : false} showBreadcrumb={false} canScroll={false}>
            {!entityName && <EstablishmentsLandingView />}
            {entityName && <List parentEntityName={undefined} 
                entityId={''} 
                entityName={entityName} 
                enableFilters={true} 
                searchType={EntityViewTypes.search} 
                canAdd={canAddEntity()} 
                tabView={false} />}
        </Layout>
    )
}
